import React from "react";
import { useNavigate } from "react-router-dom";

export default function FooterTerms() {
  const navigate = useNavigate();
  return (
    <div className="popup-message-overlay">
      <div className="main-footer-modal">
        <div className="main-footer-modal-content">
          <h1>Terms and Conditions for Harong Bikolnon Creatives</h1>
          <p className="italic">Last updated: August 1, 2025</p>
          <ol className="">
            <AcceptanceOfTerms />
            <BookingAndServices />
            <PaymentAndCancellations />
            <IntellectualProperty />
            <PrivacyPolicy />
            <Liability />
            <TermsAndConditionsChanges />
            <ContactInformation />
          </ol>
        </div>
        <div
          className="main-form-footer"
          style={{ borderRadius: "0 0 20px 20px" }}
        >
          <button
            type="submit"
            className="main-form-footer-button"
            style={{ width: "20%" }}
            onClick={() => navigate(-1)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function AcceptanceOfTerms() {
  return (
    <li>
      <span>Acceptance of the Terms and Conditions</span>
      <p>
        You acknowledge and agree to comply by these Terms and Conditions by
        accessing or using the services offered by Harong Bikolnon Creatives.
      </p>
    </li>
  );
}

function BookingAndServices() {
  return (
    <li>
      <span>Booking and Services</span>
      <ol>
        <li>
          <span>Booking</span>
          <p>
            You might be asked to submit correct and comprehensive information,
            such as show details and personal information, in order to reserve
            tickets for our theatrical plays.
          </p>
        </li>
        <li>
          <span>Service Agreement</span>
          <p>
            A unique service agreement outlining the terms, conditions, and
            ticket details pertaining to the theatrical play performances is
            applicable to each booking.
          </p>
        </li>
      </ol>
    </li>
  );
}

function PaymentAndCancellations() {
  return (
    <li>
      <span>Payments and Cancellations</span>
      <ol>
        <li>
          <span>Payment</span>
          <p>
            The service agreement will contain information about payment
            specifics, such as costs and modes of payment. The terms of the
            agreement specify when payment is due.
          </p>
        </li>
        <li>
          <span>Cancellations</span>
          <p>
            There can be fees associated with cancellations, as specified in the
            service agreement. Please review the particular terms that apply to
            each ticket reservation.
          </p>
        </li>
      </ol>
    </li>
  );
}

function IntellectualProperty() {
  return (
    <li>
      <span>Intellectual Property</span>
      <ol>
        <li>
          <span>Ownership</span>
          <p>
            The intellectual property rights, including copyrights, of all
            theatrical performances and related materials created by Harong
            Bikolnon Creatives remain the property of the company. Audiences are
            granted personal viewing rights as specified in the ticket
            agreement.
          </p>
        </li>
        <li>
          <span>Usage</span>
          <p>
            Audiences are prohibited from recording, reproducing, or
            distributing the performances for commercial purposes without
            obtaining written consent from Harong Bikolnon Creatives.
          </p>
        </li>
      </ol>
    </li>
  );
}

function PrivacyPolicy() {
  return (
    <li>
      <span>Privacy Policy</span>
      <p>
        Additionally, our Privacy Policy, which describes how we gather, use,
        and safeguard your personal information, governs how you use our
        services. For further information, please consult our privacy policy.
      </p>
    </li>
  );
}

function Liability() {
  return (
    <li>
      <span>Restrictions on Liability</span>
      <p>
        Harong Bikolnon Creatives disclaims all liability for any damages
        resulting from the use of our services or from the inability to use
        them, including but not limited to direct, indirect, incidental, or
        consequential damages.
      </p>
    </li>
  );
}

function TermsAndConditionsChanges() {
  return (
    <li>
      <span>Changes to Terms and Conditions</span>
      <p>
        These terms and conditions could be updated at any time by Harong
        Bikolnon Creatives. The updated conditions will take effect as soon as
        they are posted on our website.
      </p>
    </li>
  );
}

function ContactInformation() {
  return (
    <li>
      <span>Contact Information</span>
      <p>
        If you have any questions or concerns about our Terms and Conditions,
        please contact us at +63967372742/+639457936100
      </p>
    </li>
  );
}
